// import React, { useState } from "react";
// import { Container, Typography, Button } from "@mui/material";
// import CommonFields from "../FormFields/CommonForm";
// import "../css/registerform.css"; // reuse same css if possible
// import axiosInstance from "../../utils/axiosInstance";
// import Loader from "../Loader/Loader";
// import { showErrorToast, showSuccessToast } from "../toast";
// const JobRegistration = () => {
//   const [values, setValues] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     dob: "",
//     country: "",
//     state: "",
//     city: "",
//     address: "",
//     referralName: "",
//     resumeFile: null,
//     recordType: "job",
//     formType: "job",
//   });

//   const [loading, setLoading] = useState(false);

//   const [requiredFields] = useState(["firstName", "email", "phone", "dob", "country", "state", "city", "address"]);
//   const [errors, setErrors] = useState({});

//   const activeFields = [
//     "firstName",
//     "lastName",
//     "email",
//     "phone",
//     "dob",
//     "address",
//     "country",
//     "state",
//     "city",
//     "referalRadio",
//     "referralName",
//     "resumeRadio",
//     "resumeFile",
//   ];

//   const validate = () => {
//     let tempErrors = {};

//     requiredFields.forEach((field) => {
//       if (!values[field]) {
//         tempErrors[field] = "This field is required";
//       }
//     });

//     setErrors(tempErrors);
//     return Object.keys(tempErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validate()) return;
//     setLoading(true);
//     try {
//       const formData = new FormData();

//       // Append all fields dynamically
//       Object.keys(values).forEach((key) => {
//         if (values[key] !== null && values[key] !== undefined) {
//           formData.append(key, values[key]);
//         }
//       });

//       // Append resume file separately
//       if (values.resumeFile) {
//         formData.append("resumeFile", values.resumeFile);
//       }

//       console.log("Submitting form with data:", values);
//       const response = await axiosInstance.post(
//         "/api/JobPortal/register",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       if (!response.data) {
//         showErrorToast("Failed to submit form");
//       }

//       showSuccessToast("Form submitted successfully!");
//       setLoading(false);
//       setValues({
//         firstName: "",
//         lastName: "",
//         email: "",
//         phone: "",
//         dob: "",
//         country: "",
//         state: "",
//         city: "",
//         address: "",
//         referralName: "",
//         resumeFile: null,
//         resumeRadio: "no",
//         resumeRadio: "no",
//         recordType: "job",
//         formType: "job",
//       });
//       setErrors({});
//     } catch (error) {
//       console.error("Error:", error);
//     } finally {
//       setLoading(false);
//       setErrors({});
//     }
//   };

//   return (
//     <Container maxWidth="lg" sx={{ mt: 12 }}>
//       {loading && <Loader />}
//       <div className="card contact-form w-100">
//         <div className="text-center">
//           <div className="content-heading text-header">Join Our Team</div>
//         </div>

//         <h4 className="registerHead">Job Registration Form</h4>

//         <form
//           onSubmit={handleSubmit}
//           className="p-3 border rounded shadow formbg"
//         >
//           <CommonFields
//             values={values}
//             setValues={setValues}
//             requiredFields={requiredFields}
//             errors={errors}
//             setErrors={setErrors}
//             fields={activeFields}
//           />

//           <Button
//             type="submit"
//             fullWidth
//             variant="contained"
//             sx={{ mt: 3 }}
//             className="btnmesg"
//           >
//             Submit
//           </Button>
//         </form>
//       </div>
//     </Container>
//   );
// };

// export default JobRegistration;

import React, { useState, useRef } from "react";
import { Container, Typography, Button, Paper } from "@mui/material";
import { Button as BootstrapButton } from "react-bootstrap";
import CommonFields from "../FormFields/CommonForm";
// import "../css/registerform.css";
import "../css/jobapply.css";
import axiosInstance from "../../utils/axiosInstance";
import {
  showErrorToast,
  showSuccessToast,
  showCenterErrorToast,
} from "../toast";
import Loader from "../Loader/Loader";
import ApplyImg from "../img/job-apply.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";

const generateCaptcha = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return captcha;
};

const JobRegistration = () => {
  const resumeInputRef = useRef(null);
  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dob: "",
    country: "India",
    state: "",
    city: "",
    address: "",
    referralName: "",
    resumeFile: null,
    referalRadio: "",
    resumeRadio: "",
    recordType: "job",
    formType: "job",
    stage: "job",
    hasDegree: "", // "yes" or "no"
    degree: "",
    graduationYear: "",
    jobType: "",
    hasExperience: "", // "yes" or "no"
    experience: "",
    remarks: "",
  });

  const [loading, setLoading] = useState(false);

  const [requiredFields] = useState(["firstName", "lastName", "email", "phone", "jobType", "state", "city", "resumeFile"]);
  const [errors, setErrors] = useState({});
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");

  const activeFields = [
    "firstName",
    "lastName",
    "email",
    "phone",
    "address",
    "country",
    "state",
    "city",
    "referalRadio",
    "referralName",
    "resumeRadio",
    "resumeFile",
    "hasDegree",
    "degree",
    "graduationYear",
    "hasExperience",
    "experience",
    "remarks",
    "jobType",
  ];

  const validate = () => {
    let tempErrors = {};

    requiredFields.forEach((field) => {
      if (!values[field]) tempErrors[field] = "This field is required";
    });

    if (values.hasDegree === "yes") {
      if (!values.degree) tempErrors.degree = "This field is required";
    }

    if (values.hasExperience === "yes") {
      if (!values.experience)
        tempErrors.experience = "Years of Experience is required";
    }

    if (values.experience && Number(values.experience) < 0) {
      tempErrors.experience = "Experience must be a positive number";
    }

    if (values.graduationYear && Number(values.graduationYear) < 0) {
      tempErrors.graduationYear = "Graduation Year must be a positive number";
    }

    if (values.email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;
      if (!emailRegex.test(values.email))
        tempErrors.email = "Invalid email address";
    }

    if (values.phone) {
      const phoneRegex = /^\+?[0-9]{10,15}$/;
      if (!phoneRegex.test(values.phone))
        tempErrors.phone = "Invalid phone number";
    }

    if (!captchaInput?.trim()) {
      tempErrors.captcha = "Captcha is required";
    } else if (captchaInput !== captcha) {
      tempErrors.captcha = "Captcha does not match";
    }

    if (values.city === "Others") {
      if (!values.location || !values.location.trim()) {
        tempErrors.location = "Location is required";
      }
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleApiError = (error) => {
    if (!error.response) {
      showErrorToast("Server not reachable. Please try again later.");
      return;
    }

    const { status, data } = error.response;

    //409 Conflict
    if (status === 409) {
      showCenterErrorToast("Email already exists");
      return;
    }

    // fallback
    showErrorToast("Something went wrong. Please try again.");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    if (!validate()) return;

    setLoading(true);
    try {
      const formData = new FormData();

      // Append all fields dynamically
      Object.keys(values).forEach((key) => {
        if (values[key] !== null && values[key] !== undefined) {
          formData.append(key, values[key]);
        }
      });

      // Append resume file separately
      if (values.resumeFile) {
        formData.append("resumeFile", values.resumeFile);
      }

      const finalCity = values.city === "Others" ? values.location : values.city;

      const payload = {
        ...values,
        city: finalCity,
      };


      console.log("Submitting form with data:", payload);
      const response = await axiosInstance.post(
        "/api/JobPortal/register",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (!response.data) {
        showErrorToast("Failed to submit form");
      }

      showSuccessToast("Form submitted successfully!");
      setLoading(false);
      setValues({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        country: "India",
        state: "",
        city: "",
        address: "",
        referralName: "",
        resumeFile: null,
        referalRadio: "",
        resumeRadio: "",
        recordType: "job",
        formType: "job",
        stage: "job",
        hasDegree: "",
        degree: "",
        graduationYear: "",
        jobType: "",
        hasExperience: "",
        experienceYears: "",
        companyName: "",
        remarks: "",
      });
      setCaptcha(generateCaptcha());
      setCaptchaInput("");
      if (resumeInputRef.current) {
        resumeInputRef.current.value = "";
      }
      setErrors({});
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
      setErrors({});
    }
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 12 }}>
        {loading && <Loader />}

        <div className="jobapply-wrapper">

          {/* LEFT IMAGE */}
          <div className="jobapply-left ">
            <div style={{ display: "block" }}>
              <h1 className="jobheading text-center">Grow Your Career</h1>
              <img
                src={ApplyImg}
                alt="Job Apply Illustration"
                className="jobapply-image"
              />
            </div></div>

          {/* RIGHT FORM */}
          <div className="jobapply-right">
            <Paper elevation={4} className="jobapply-paper">
              <div className="text-center">
                <h2 className="jobapply-title">Join Our Team</h2>
              </div>

              <hr className="jobapply-divider" />

              <h4 className="registerHead text-center mb-3">
                Apply @ Tiara Jobs
              </h4>

              <form
                onSubmit={handleSubmit}
                className="p-3 border rounded formbg"
              >
                <CommonFields
                  values={values}
                  setValues={setValues}
                  requiredFields={requiredFields}
                  errors={errors}
                  setErrors={setErrors}
                  fields={activeFields}
                  resumeInputRef={resumeInputRef}
                />

                {/* Captcha */}
                <div className="mb-2">
                  <label>
                    Captcha <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex align-items-center gap-3">
                    <input
                      className="form-control text-center"
                      value={captchaInput}
                      onChange={(e) => setCaptchaInput(e.target.value)}
                      style={{ maxWidth: "200px" }}
                    />
                    <strong className="px-3 py-2 bg-light border rounded">
                      {captcha}
                    </strong>
                    <BootstrapButton
                      type="button"
                      variant="light"
                      onClick={() => {
                        setCaptcha(generateCaptcha());
                        setCaptchaInput("");
                      }}
                    >
                      <FontAwesomeIcon icon={faRotateRight} />
                    </BootstrapButton>
                  </div>
                  <small className="text-danger">{errors.captcha}</small>
                </div>

                <div className="row btn-containers">
                  <Button
                    type="submit"
                    variant="contained"
                    className="submitbtn"
                    sx={{
                      mt: 1,
                      py: 1,
                      fontWeight: "bold",
                      borderRadius: "8px",
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </Paper>
          </div>
        </div>
      </Container>
    </>
  );
};

export default JobRegistration;
